/* eslint-disable import/prefer-default-export */

import PropTypes from 'prop-types';

export const DATAPOINT_SHAPE = {
  category: PropTypes.string,
  subcategory: PropTypes.string,
  subdivision: PropTypes.string,
  value: PropTypes.number,
  year: PropTypes.number,
};

export const DATA_SHAPE = {
  data: PropTypes.arrayOf(PropTypes.shape(DATAPOINT_SHAPE)),
  label: PropTypes.string,
};

export const FILTER_SHAPE = {
  // This is really a recursive reference to FILTER_SHAPE but PropTypes won't let you recurse.
  children: PropTypes.arrayOf(PropTypes.shape({})),
  label: PropTypes.string,
  slug: PropTypes.string,
};

export const FILTERS_SHAPE = {
  outputType: PropTypes.string,
  serviceType: PropTypes.arrayOf(PropTypes.string),
  sourceOfFunds: PropTypes.arrayOf(PropTypes.string),
  tab: PropTypes.oneOf([0, 1, 2, 3]),
  yearCompare: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  yearRange: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  yearSingle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  yearType: PropTypes.oneOf(['compare', 'range', 'single']),
};

export const OPTION_SHAPE = {
  label: PropTypes.string,
  value: PropTypes.string,
};
